import Form from './ReservationConfirmationForm';
import { injectReservationModuleForm, injectSmartDetailForm } from './inject';

export const ReservationModuleConfirmationForm = injectReservationModuleForm(Form);
export const SmartDetailConfirmationForm = injectSmartDetailForm(Form);
